import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import OffresPage from "@/pages/OffresPage";
import PackVisibilitePage from "@/pages/PackVisibilitePage";
import PackImagePremiumPage from "@/pages/PackImagePremiumPage";
import PackCroissancePage from "@/pages/PackCroissancePage";
import ServicesCartePage from "@/pages/ServicesCartePage";
import Accompagnement360Page from "@/pages/Accompagnement360Page";
import AProposPage from "@/pages/AProposPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:category" element={<ServicesPage />} />
                <Route path="/offres" element={<OffresPage />} />
                <Route path="/offres/visibilite-360" element={<PackVisibilitePage />} />
                <Route path="/offres/image-premium" element={<PackImagePremiumPage />} />
                <Route path="/offres/croissance-plus" element={<PackCroissancePage />} />
                <Route path="/offres/services-carte" element={<ServicesCartePage />} />
                <Route path="/offres/accompagnement-360" element={<Accompagnement360Page />} />
                <Route path="/a-propos" element={<AProposPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
